import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getHomeFallbackPath } from '@/utils/whiteLabelStore';

/**
 * Página raiz dos hosts white-label (domínio do fornecedor).
 *
 * Regra de negócio: nesses domínios nada da marca AmeUp pode aparecer.
 * Por isso a home institucional é substituída por:
 *  1. redirecionamento para o último caminho de loja conhecido; ou
 *  2. uma mensagem neutra, sem qualquer branding.
 */
const WhiteLabelLanding = (): JSX.Element => {
  const fallbackPath = getHomeFallbackPath();

  if (fallbackPath !== '/') {
    return <Navigate to={fallbackPath} replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Helmet>
        <title>Loja Digital</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-md text-center space-y-3">
        <h1 className="text-2xl font-semibold text-foreground">Loja Digital</h1>
        <p className="text-muted-foreground">
          Acesse o endereço completo da loja enviado pelo estabelecimento para ver o cardápio.
        </p>
      </div>
    </div>
  );
};

export default WhiteLabelLanding;
